import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Button } from "flowbite-react";
import { useFormikWrapper } from "../../components/formik_wrapper"
import * as Yup from "yup";
import { toast } from "react-toastify";

import { LOGIN_REQ } from "../../actions";
import "react-toastify/dist/ReactToastify.css";
import { TextBox } from "../../components/inputs/index";

function Login() {
  const navigate = useNavigate();
  const user = useSelector((state) => state.user);
  const dispatch = useDispatch();

  useEffect(() => {
    if (user && user.token) navigate("/");
  }, []);

  useEffect(() => {
    if (loginForm.submitCount > 0) {
      loginForm.setSubmitting(false);

      if (user && user.token) {
        navigate("/home");
      } else {
        toast.error(user.error?.message || "Failed to login!");
      }
    }
  }, [user]);

  const location = useLocation();
  useEffect(() => {
    let currentTitle = (location.pathname || "/").split("/")[1];
    document.title =
      "Internal Admin - " +
      currentTitle.charAt(0).toUpperCase() +
      currentTitle.slice(1);
  }, [location.pathname]);

  const loginValidation = Yup.object({
    email: Yup.string()
      .required("email is required")
      .email("please enter a valid email"),
    password: Yup.string().required("password is required"),
    two_fa_secret_key: Yup.string()
      .required("2FA key is required")
      .length(6, "Please enter a valid 2FA key"),
  });

  const loginForm = useFormikWrapper({
    initialValues: {
      email: "",
      password: "",
      two_fa_secret_key: "",
    },
    validationSchema: loginValidation,
    onSubmit: () => {
      dispatch(LOGIN_REQ(loginForm.values));
      return;
    },
  });

  return (
    <div className="flex flex-col bg-white h-screen">
      <div className="flex min-h-full flex-1">
        <div className="relative hidden w-0 flex-1 lg:block">
          <img
            className="absolute inset-0 h-full w-full object-cover"
            src="https://images.unsplash.com/photo-1620641788421-7a1c342ea42e?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1908&q=80"
            alt=""
          />
        </div>
        <div className="flex flex-1 flex-col justify-center px-4 py-6 sm:px-6 lg:flex-none lg:px-20 xl:px-24">
          <div className="mx-auto w-full max-w-sm lg:w-96 -mt-10">
            <div>
              <img
                className="h-10 w-auto"
                src="https://assets-global.website-files.com/62b4a93516caf13604744768/62cfcbb0937956380eea27cd_zuper-logo.svg"
                alt="Your Company"
              />
              <h2 className="mt-8 text-2xl font-bold leading-9 tracking-tight text-gray-900">
                Sign in to your account
              </h2>
            </div>
            <div className="mt-10">
              <div>
                <form
                  onSubmit={(e) => {
                    e.preventDefault();
                  }}
                  className="space-y-4"
                >
                  <TextBox
                    name="email"
                    label="Email Address"
                    placeholder="Eg: andy@zuper.co"
                    type="email"
                    formik={loginForm}
                  />

                  <TextBox
                    name="password"
                    label="Password"
                    placeholder="************"
                    type="password"
                    formik={loginForm}
                  />

                  <TextBox
                    name="two_fa_secret_key"
                    label="2FA key"
                    placeholder="2FA key"
                    formik={loginForm}
                  />

                  <div>
                    <Button
                      type="submit"
                      disabled={loginForm.isSubmitting}
                      onClick={loginForm.handleSubmit}
                      className="mt-2 w-full justify-center rounded-md bg-indigo-600 px-3 py-2 text-sm font-semibold leading-6 text-white shadow-sm hover:bg-indigo-500  focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
                    >
                      Sign in
                    </Button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Login;
